export function getMaskedPhone(phone: string): string {
  const digits = phone.replace(/[^+\d]/g, '');

  const match = digits.match(/^(\+?\d{1,3})?(\d{3})(\d{4})(\d{3})$/);
  if (match) {
    const [, country = '', , , last3] = match;
    return `${country} ••• •••• ${last3}`;
  }

  return phone;
}

export function getMaskedEmail(email: string): string {
  const [local, domain] = email.split('@');
  if (!local || !domain) return email;

  const visibleStart = local.slice(0, 3);
  const visibleEnd = local.slice(-1);
  const masked = '•'.repeat(Math.max(local.length - 4, 1));

  return `${visibleStart}${masked}${visibleEnd}@${domain}`;
}
